import { render, staticRenderFns } from "./DeliveryIncomeByArea.vue?vue&type=template&id=508141ed&lang=pug&"
import script from "./DeliveryIncomeByArea.vue?vue&type=script&lang=ts&"
export * from "./DeliveryIncomeByArea.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryIncomeByArea.vue?vue&type=style&index=0&id=508141ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports